// import React, { useEffect, useState } from "react";
// import { RefreshCcw } from "react-feather";
// import { Dropdown, Input, Select, Button, Pagination, Badge, Descriptions } from "antd";
// import { MoreOutlined } from "@ant-design/icons";
// import { useToast } from "../../Toaster/ToastContext";
// import { apiClient } from "../../services/apiClient";
// import SalesModal from "../../core/modals/sales/SalesModal";
// import { PlusCircle } from "feather-icons-react/build/IconComponents";
// import Loader from "../loader/loader";
// import PropTypes from "prop-types";

// const CustomSaleDetailModal = ({ open, onClose, sale }) => {
//   if (!open) return null;

//   return (
//     <div className="custom-modal-overlay">
//       <div className="custom-modal">
//         <div className="modal-header">
//           <h2>Sale Details</h2>
//           <button className="close-btn" onClick={onClose}>
//             ×
//           </button>
//         </div>
//         <div className="modal-body">
//           {sale ? (
//             <Descriptions
//               bordered
//               column={1}
//               size="middle"
//               className="sale-descriptions"
//               labelStyle={{ fontWeight: "bold", width: "30%" }}
//               contentStyle={{ width: "70%" }}
//             >
//               <Descriptions.Item label="Customer">
//                 {sale.customer || "N/A"}
//               </Descriptions.Item>
//               <Descriptions.Item label="Reference">
//                 {sale.reference || "N/A"}
//               </Descriptions.Item>
//               <Descriptions.Item label="Date">
//                 {sale.date || "N/A"}
//               </Descriptions.Item>
//               <Descriptions.Item label="Status">
//                 <Badge
//                   status={sale.status === "Completed" ? "success" : "warning"}
//                   text={sale.status || "N/A"}
//                 />
//               </Descriptions.Item>
//               <Descriptions.Item label="Grand Total">
//                 PKR {sale.grand_total || "0.00"}
//               </Descriptions.Item>
//               <Descriptions.Item label="Paid">
//                 PKR {sale.paid || "0.00"}
//               </Descriptions.Item>
//               <Descriptions.Item label="Due">
//                 PKR {sale.due || "0.00"}
//               </Descriptions.Item>
//               <Descriptions.Item label="Payment Status">
//                 <span
//                   className={`badge badge-soft-${
//                     sale.payment_status === "Paid"
//                       ? "success"
//                       : sale.payment_status === "Unpaid"
//                       ? "warning"
//                       : "danger"
//                   } shadow-none badge-xs`}
//                 >
//                   <i className="ti ti-point-filled me-1"></i>
//                   {sale.payment_status || "N/A"}
//                 </span>
//               </Descriptions.Item>
//             </Descriptions>
//           ) : (
//             <p>No sale details available.</p>
//           )}
//         </div>
//         <div className="modal-footer">
//           <Button key="close" onClick={onClose} type="primary">
//             Close
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// CustomSaleDetailModal.propTypes = {
//   open: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
//   sale: PropTypes.shape({
//     customer: PropTypes.string,
//     reference: PropTypes.string,
//     date: PropTypes.string,
//     status: PropTypes.string,
//     grand_total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     paid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     due: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     payment_status: PropTypes.string,
//   }),
// };

// const SalesList = () => {
  
//   const { showToast } = useToast();
//   const [permissions, setPermissions] = useState({
//     create: false,
//     read: false,
//     update: false,
//     delete: false,
//   });

//   const [open, setOpen] = useState(false);
//   const [sales, setSales] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [searchCustomer, setSearchCustomer] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [selectedSale, setSelectedSale] = useState(null);
//   const [detailModalOpen, setDetailModalOpen] = useState(false);
//   const [pagination, setPagination] = useState({
//     current_page: 1,
//     last_page: 1,
//     total: 0,
//     per_page: 10,
//   });

//   // const [selectedStatus, setSelectedStatus] = useState(null);
//   // const [selectedPayment, setSelectedPayment] = useState(null);
//   // const [selectedSort, setSelectedSort] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     const storedPermissions = localStorage.getItem("rolespermissions");
//     let parsedPermissions = [];
//     try {
//       const Permissions = JSON.parse(storedPermissions);
//       const getPermissions = JSON.parse(Permissions.permissions);
//       parsedPermissions = getPermissions.permissions
//         ? getPermissions.permissions
//         : getPermissions;
//       const salesPermissions = parsedPermissions.find(
//         (item) => item.title === "Sales"
//       );

//       const salesListPermissions = salesPermissions?.childPage?.find(
//         (child) => child.title === "Sales" // matches your JSON
//       );
//       if (salesListPermissions) {
//         setPermissions({
//           create: salesListPermissions.create || false,
//           read: salesListPermissions.read || false,
//           update: salesListPermissions.update || false,
//           delete: salesListPermissions.delete || false,
//         });
//       } else {
//         console.error("Sales permissions not found:", salesPermissions);
//         showToast("Sales permissions not found.", "error", "Permissions Error");
//       }
//     } catch (error) {
//       console.error("Error parsing permissions from localStorage:", error);
//       showToast("Failed to load permissions.", "error", "Permissions Error");
//     }
//   }, []);

//   const fetchSales = async (
//     per_page = 10,
//     customer = null,
//     status = null,
//     paymentStatus = null,
//     sort = ""
//   ) => {
//     setLoading(true);
//     try {
//       const response = await apiClient.post("/get-all-sale", {
//         per_page,
//         customer: customer,
//         status,
//         payment_status: paymentStatus,
//         sort,
//       });
//       if (response.status) {
//         setSales(response.sales || []);
//         setPagination(response.pagination);
//       } else {
//         showToast(
//           "Sales could not be fetched. Please try again.",
//           "error",
//           "Sales"
//         );
//       }
//     } catch (err) {
//       showToast("Failed to fetch sales. Try again.", "error", "Sales");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCustomers = async () => {
//     try {
//       const res = await apiClient.get("/get-all-customer");
//       if (res.success) setCustomers(res.data || []);
//     } catch (err) {
//       showToast("Failed to fetch customers.", "error", "Customers");
//     }
//   };

//   useEffect(() => {
//     fetchCustomers();
//     fetchSales();
//   }, []);

//   const handleCustomerFilter = (id) => {
//     setSelectedCustomer(id);
//     fetchSales(10, id);
//   };

//   const handlePageChange = (page) => {
//     fetchSales(page, selectedCustomer);
//   };

//   const handleAddSale = async (salePayload) => {
//     try {
//       const response = await apiClient.post("/store-sale", salePayload);
//       if (response?.status === false) {
//         showToast(response.message || "Failed to place order.", "error", "POS");
//         throw new Error(response.message || "Failed to place order.");
//       }
//       showToast(
//         response.message || "Order placed successfully!",
//         "success",
//         "POS"
//       );
//       setOpen(false);
//       fetchSales(pagination.per_page, selectedCustomer);
//       return response;
//     } catch (err) {
//       const message =
//         err?.response?.data?.message ||
//         err?.message ||
//         "Failed to place order. Try again.";
//       showToast(message, "error", "POS");
//       throw err;
//     }
//   };

//   const handleActionClick = ({ key }, sale) => {
//     switch (key) {
//       case "view":
//         setSelectedSale(sale);
//         setDetailModalOpen(true);
//         break;
//       case "return":
//         handleSalesReturn(sale);
//         break;
//       default:
//         break;
//     }
//   };

//   const handleSalesReturn = async (sale) => {
//     try {
//       setLoading(true);
//       const response = await apiClient.post("/return-sale", {
//         sale_id: sale.id,
//       });
//       if (response.success) {
//         showToast(
//           response.message || "Sales return successfully!",
//           "success",
//           "Sales Return"
//         );
//         fetchSales(pagination.per_page, selectedCustomer);
//       } else {
//         showToast(
//           response.message || "Failed to return sale. Try again.",
//           "error",
//           "Sales Return"
//         );
//       }
//     } catch (err) {
//       const message =
//         err?.response?.data?.message ||
//         err?.message ||
//         "An error occurred. Try again.";
//       showToast(message, "error", "Sales Return");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getSaleActionsMenu = (sale) => {
//     const items = [
//       {
//         key: "return",
//         label: <span style={{ display: "block" }}>Sales Return</span>,
//       },
//     ];
//     if (permissions.read) {
//       items.unshift({
//         key: "view",
//         label: (
//           <span style={{ display: "block", padding: "5px 12px" }}>
//             Sale Detail
//           </span>
//         ),
//       });
//     }
//     return { items, onClick: (info) => handleActionClick(info, sale) };
//   };

//   const filteredCustomers = customers.filter((cust) =>
//     cust.customer_name.toLowerCase().includes(searchCustomer.toLowerCase())
//   );

//   const filteredSales = sales.filter((sale) => {
//     if (!searchTerm) return true;
//     const searchLower = searchTerm.toLowerCase();
//     return (
//       (sale.customer && sale.customer.toLowerCase().includes(searchLower)) ||
//       (sale.reference && sale.reference.toLowerCase().includes(searchLower)) ||
//       (sale.status && sale.status.toLowerCase().includes(searchLower)) ||
//       (sale.payment_status &&
//         sale.payment_status.toLowerCase().includes(searchLower))
//     );
//   });

//   return (
//     <>
//       <Loader loading={loading} />
//       <div className="page-wrapper">
//         <div className="content">
//           <div className="page-header">
//             <div className="add-item d-flex">
//               <div className="page-title">
//                 <h4>Sales</h4>
//                 <h6>Manage Your Sales</h6>
//               </div>
//             </div>
//             <ul className="table-top-head">
//               <li>
//                 <a
//                   title="Refresh"
//                   onClick={() =>
//                     fetchSales(pagination.per_page, selectedCustomer)
//                   }
//                 >
//                   <RefreshCcw />
//                 </a>
//               </li>
//             </ul>
//             {permissions.create && (
//               <div className="page-btn">
//                 <Button
//                   className="btn btn-primary d-flex gap-2 align-items-center"
//                   onClick={() => setOpen(true)}
//                 >
//                   <PlusCircle size={14} /> Add Sales
//                 </Button>
//               </div>
//             )}
//           </div>

//           <div className="card">
//             <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
//               <div className="search-set">
//                 <div className="search-input">
//                   <Input
//                     placeholder="Search by customer name, reference, status and payment status"
//                     prefix={
//                       <i className="ti ti-search fs-14 feather-search"></i>
//                     }
//                     className="input"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                   />
//                 </div>
//               </div>
//               <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
//                 <Select
//                   showSearch
//                   allowClear
//                   placeholder="Customer"
//                   className="me-2"
//                   style={{ width: 200 }}
//                   onSearch={setSearchCustomer}
//                   onChange={handleCustomerFilter}
//                   filterOption={false}
//                 >
//                   {filteredCustomers.map((cust) => (
//                     <Select.Option
//                       key={cust.customer_name}
//                       value={cust.customer_name}
//                     >
//                       {cust.customer_name}
//                     </Select.Option>
//                   ))}
//                 </Select>

//                 {/* <Dropdown
//                   menu={{
//                     onClick: ({ key }) => {
//                       setSelectedStatus(key || null);
//                       fetchSales(
//                         10,
//                         selectedCustomer,
//                         key || null,
//                         selectedPayment,
//                         selectedSort
//                       );
//                     },
//                     items: [
//                       { key: "", label: "" },
//                       { key: "completed", label: "Completed" },
//                       { key: "returned", label: "Returned" },
//                     ],
//                   }}
//                 >
//                   <Button className="me-2">
//                     {selectedStatus ? `Status: ${selectedStatus}` : "Status"}
//                   </Button>
//                 </Dropdown> */}

//                 {/* <Dropdown
//                   menu={{
//                     onClick: ({ key }) => {
//                       setSelectedPayment(key || null);
//                       fetchSales(
//                         10,
//                         selectedCustomer,
//                         // selectedStatus,
//                         key || null,
//                         selectedSort
//                       );
//                     },
//                     items: [
//                       { key: "", label: "" },
//                       { key: "paid", label: "Paid" },
//                       { key: "unpaid", label: "Unpaid" },
//                     ],
//                   }}
//                 >
//                   <Button className="me-2">
//                     {selectedPayment
//                       ? `Payment: ${selectedPayment}`
//                       : "Payment Status"}
//                   </Button>
//                 </Dropdown> */}

//                 {/* <Dropdown
//                   menu={{
//                     onClick: ({ key }) => {
//                       let label = key;
//                       if (key === "asc") label = "Ascending";
//                       if (key === "desc") label = "Descending";
//                       setSelectedSort(label);
//                       fetchSales(
//                         10,
//                         selectedCustomer,
//                         // selectedStatus,
//                         // selectedPayment,
//                         key
//                       );
//                     },
//                     items: [
//                       { key: "", label: "" },
//                       { key: "asc", label: "Ascending" },
//                       { key: "desc", label: "Descending" },
//                     ],
//                   }}
//                 >
//                   <Button>Sort By: {selectedSort}</Button>
//                 </Dropdown> */}
//               </div>
//             </div>

//             <div className="card-body p-0">
//               <div className="table-responsive">
//                 <table className="table datatable">
//                   <thead className="thead-light">
//                     <tr>
//                       <th style={{ width: 200 }}>Customer</th>
//                       <th style={{ width: 200 }}>Reference</th>
//                       <th style={{ width: 150 }}>Date</th>
//                       <th style={{ width: 100 }}>Status</th>
//                       <th style={{ width: 150 }}>Grand Total</th>
//                       <th style={{ width: 150 }}>Paid</th>
//                       <th style={{ width: 150 }}>Due</th>
//                       <th style={{ width: 150 }}>Payment Status</th>
//                       <th style={{ width: 100 }}>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody className="sales-list">
//                     {filteredSales.map((sale) => (
//                       <tr key={sale.id}>
//                         <td>
//                           <span className="wrap-text">
//                             <a href="#">{sale.customer}</a>
//                           </span>
//                         </td>
//                         <td>
//                           <span className="wrap-text">{sale.reference}</span>
//                         </td>
//                         <td>
//                           {sale.date
//                             ? new Date(sale.date)
//                                 .toLocaleDateString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                 })
//                                 .replace(/\//g, "-")
//                             : "N/A"}
//                         </td>
//                         <td>
//                           <Badge
//                             status={
//                               sale.status === "Completed"
//                                 ? "success"
//                                 : "warning"
//                             }
//                             text={sale.status}
//                           />
//                         </td>
//                         <td>PKR {sale.grand_total}</td>
//                         <td>PKR {sale.paid}</td>
//                         <td>PKR {sale.due}</td>
//                         <td>
//                           <span
//                             className={`badge badge-soft-${
//                               sale.payment_status === "Paid"
//                                 ? "success"
//                                 : sale.payment_status === "Unpaid"
//                                 ? "warning"
//                                 : "danger"
//                             } shadow-none badge-xs`}
//                           >
//                             <i className="ti ti-point-filled me-1"></i>
//                             {sale.payment_status}
//                           </span>
//                         </td>
//                         <td className="text-center">
//                           <Dropdown
//                             menu={getSaleActionsMenu(sale)}
//                             trigger={["click"]}
//                           >
//                             <Button icon={<MoreOutlined />} />
//                           </Dropdown>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="d-flex justify-content-end p-3">
//                 <Pagination
//                   current={pagination.current_page}
//                   total={pagination.total}
//                   pageSize={pagination.per_page}
//                   onChange={handlePageChange}
//                 />
//               </div>
//             </div>
//           </div>

//           <SalesModal
//             open={open}
//             onClose={() => setOpen(false)}
//             onSubmit={handleAddSale}
//           />
//           <CustomSaleDetailModal
//             open={detailModalOpen}
//             onClose={() => setDetailModalOpen(false)}
//             sale={selectedSale}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default SalesList;

import React, { useEffect, useState } from "react";
import { RefreshCcw } from "react-feather";
import { Dropdown, Input, Select, Button, Badge, Descriptions } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useToast } from "../../Toaster/ToastContext";
import { apiClient } from "../../services/apiClient";
import SalesModal from "../../core/modals/sales/SalesModal";
import { PlusCircle} from "feather-icons-react/build/IconComponents";
import Loader from "../loader/loader";
import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const CustomSaleDetailModal = ({ open, onClose, sale }) => {

  if (!open) return null;
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <div className="modal-header">
          <h2>Sale Details</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          {sale ? (
            <Descriptions
              bordered
              column={1}
              size="middle"
              className="sale-descriptions"
              labelStyle={{ fontWeight: "bold", width: "30%" }}
              contentStyle={{ width: "70%" }}
            >
              <Descriptions.Item label="Customer">
                {sale.customer || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Reference">
                {sale.reference || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Date">
                {sale.date || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                <Badge
                  status={sale.status === "Completed" ? "success" : "warning"}
                  text={sale.status || "N/A"}
                />
              </Descriptions.Item>
              <Descriptions.Item label="Grand Total">
                PKR {sale.grand_total || "0.00"}
              </Descriptions.Item>
              <Descriptions.Item label="Paid">
                PKR {sale.paid || "0.00"}
              </Descriptions.Item>
              <Descriptions.Item label="Due">
                PKR {sale.due || "0.00"}
              </Descriptions.Item>
              <Descriptions.Item label="Payment Status">
                <span
                  className={`badge badge-soft-${
                    sale.payment_status === "Paid"
                      ? "success"
                      : sale.payment_status === "Unpaid"
                      ? "warning"
                      : "danger"
                  } shadow-none badge-xs`}
                >
                  <i className="ti ti-point-filled me-1"></i>
                  {sale.payment_status || "N/A"}
                </span>
              </Descriptions.Item>
            </Descriptions>
          ) : (
            <p>No sale details available.</p>
          )}
        </div>
        <div className="modal-footer">
          <Button key="close" onClick={onClose} type="primary">
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

CustomSaleDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sale: PropTypes.shape({
    customer: PropTypes.string,
    reference: PropTypes.string,
    date: PropTypes.string,
    status: PropTypes.string,
    grand_total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    due: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    payment_status: PropTypes.string,
  }),
};

const SalesList = () => {
  
  const { showToast } = useToast();
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });
  const [open, setOpen] = useState(false);
  const [sales, setSales] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    per_page: 20,
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);
      parsedPermissions = getPermissions.permissions
        ? getPermissions.permissions
        : getPermissions;
      const salesPermissions = parsedPermissions.find(
        (item) => item.title === "Sales"
      );

      const salesListPermissions = salesPermissions?.childPage?.find(
        (child) => child.title === "Sales"
      );
      if (salesListPermissions) {
        setPermissions({
          create: salesListPermissions.create || false,
          read: salesListPermissions.read || false,
          update: salesListPermissions.update || false,
          delete: salesListPermissions.delete || false,
        });
      } else {
        // console.error("Sales permissions not found:", salesPermissions);
        showToast("Sales permissions not found.", "error", "Permissions Error");
      }
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  const fetchSales = async (
    page = 1,
    per_page = 20,
    customer = null,
    status = null,
    paymentStatus = null,
    sort = ""
  ) => {
    setLoading(true);
    try {
      const response = await apiClient.post("/get-all-sale", {
        page,
        per_page,
        customer,
        status,
        payment_status: paymentStatus,
        sort,
      });
      if (response.status) {
        setSales(response.sales || []);
        setPagination(response.pagination);
      } else {
        showToast("Sales could not be fetched. Please try again.", "error", "Sales");
      }
    } catch (err) {
      showToast("Failed to fetch sales. Try again.", "error", "Sales");
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomers = async () => {
    try {
      const res = await apiClient.get("/get-all-customer");
      if (res.success) setCustomers(res.data || []);
    } catch (err) {
      showToast("Failed to fetch customers.", "error", "Customers");
    }
  };

  useEffect(() => {
    fetchCustomers();
    fetchSales();
  }, []);

  const handleCustomerFilter = (id) => {
    setSelectedCustomer(id);
    fetchSales(1, 30, id);
  };

  const handlePageChange = (page) => {
    fetchSales(page, pagination.per_page, selectedCustomer);
  };

  const handleAddSale = async (salePayload) => {
    try {
      const response = await apiClient.post("/store-sale", salePayload);
      if (response?.status === false) {
        showToast(response.message || "Failed to place order.", "error", "POS");
        throw new Error(response.message || "Failed to place order.");
      }
      showToast(response.message || "Order placed successfully!", "success", "POS");
      setOpen(false);
      fetchSales(pagination.current_page, pagination.per_page, selectedCustomer);
      return response;
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || "Failed to place order. Try again.";
      showToast(message, "error", "POS");
      throw err;
    }
  };

  const handleActionClick = ({ key }, sale) => {
    switch (key) {
      case "view":
        setSelectedSale(sale);
        setDetailModalOpen(true);
        break;
      case "return":
        handleSalesReturn(sale);
        break;
      default:
        break;
    }
  };

  const handleSalesReturn = async (sale) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/return-sale", {
        sale_id: sale.id,
      });
      if (response.success) {
        showToast(response.message || "Sales return successfully!", "success", "Sales Return" );
        fetchSales(pagination.current_page, pagination.per_page, selectedCustomer);
      } else {
        showToast(
          response.message || "Failed to return sale. Try again.",
          "error",
          "Sales Return"
        );
      }
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || "An error occurred. Try again.";
      showToast(message, "error", "Sales Return");
    } finally {
      setLoading(false);
    }
  };

  const getSaleActionsMenu = (sale) => {
    const items = [
      {
        key: "return",
        label: <span style={{ display: "block" }}>Sales Return</span>,
      },
    ];
    if (permissions.read) {
      items.unshift({
        key: "view",
        label: (
          <span style={{ display: "block", padding: "5px 12px" }}>
            Sale Detail
          </span>
        ),
      });
    }
    return { items, onClick: (info) => handleActionClick(info, sale) };
  };

  const filteredCustomers = customers.filter((cust) =>
    cust.customer_name.toLowerCase().includes(searchCustomer.toLowerCase())
  );

  const filteredSales = sales.filter((sale) => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      (sale.customer && sale.customer.toLowerCase().includes(searchLower)) ||
      (sale.reference && sale.reference.toLowerCase().includes(searchLower)) ||
      (sale.status && sale.status.toLowerCase().includes(searchLower)) ||
      (sale.payment_status &&
        sale.payment_status.toLowerCase().includes(searchLower))
    );
  });

  // Custom pagination logic
  const { current_page, per_page, total, last_page } = pagination;
  const startItem = total > 0 ? (current_page - 1) * per_page + 1 : 0;
  const endItem = Math.min(startItem + per_page - 1, total);

  const pagesToShow = [];
  if (last_page > 0) {
    if (last_page <= 2) {
      for (let i = 1; i <= last_page; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (current_page === 1) {
        middle = [1, 2];
      } else if (current_page === last_page) {
        middle = [last_page - 1, last_page];
      } else {
        middle = [current_page, current_page + 1];
      }

      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < last_page - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < last_page) {
        pagesToShow.push(last_page);
      }
    }
  }

  const changePage = (page) => {
    handlePageChange(page);
  };

  return (
    <>
    <Loader loading={loading} />
      <div className="page-wrapper" style={{ position: "relative", minHeight: "100vh" }}>
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Sales</h4>
                <h6>Manage Your Sales</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <a title="Refresh"
                  onClick={() =>
                    fetchSales(pagination.current_page, pagination.per_page, selectedCustomer)
                  }
                >
                  <RefreshCcw />
                </a>
              </li>
            </ul>
            {permissions.create && (
              <div className="page-btn">
                <Button className="btn btn-primary d-flex gap-2 align-items-center" onClick={() => setOpen(true)}>
                  <PlusCircle size={14} /> Add Sales
                </Button>
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
                <div className="search-input">
                  <Input placeholder="Search by customer name, reference, status and payment status"
                    prefix={
                      <i className="ti ti-search fs-14 feather-search"></i>
                    }
                    className="input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <Select
                  showSearch
                  allowClear
                  placeholder="Customer"
                  className="me-2"
                  style={{ width: 200 }}
                  onSearch={setSearchCustomer}
                  onChange={handleCustomerFilter}
                  filterOption={false}
                >
                  {filteredCustomers.map((cust) => (
                    <Select.Option
                      key={cust.customer_name}
                      value={cust.customer_name}
                    >
                      {cust.customer_name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive" style={{padding: '0 24px'}}>
                <table className="table datatable">
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: 200 }}>Customer</th>
                      <th style={{ width: 200 }}>Reference</th>
                      <th style={{ width: 150 }}>Date</th>
                      <th style={{ width: 100 }}>Status</th>
                      <th style={{ width: 150 }}>Grand Total</th>
                      <th style={{ width: 150 }}>Paid</th>
                      <th style={{ width: 150 }}>Due</th>
                      <th style={{ width: 150 }}>Payment Status</th>
                      <th style={{ width: 100 }}>Action</th>
                    </tr>
                  </thead>
                  <tbody className="sales-list">
                    {filteredSales.map((sale) => (
                      <tr key={sale.id}>
                        <td>
                          <span className="wrap-text">
                            <a href="#">{sale.customer}</a>
                          </span>
                        </td>
                        <td>
                          <span className="wrap-text">{sale.reference}</span>
                        </td>
                        <td>
                          {sale.date
                            ? new Date(sale.date)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })
                                .replace(/\//g, "-")
                            : "N/A"}
                        </td>
                        <td>
                          <Badge
                            status={
                              sale.status === "Completed"
                                ? "success"
                                : "warning"
                            }
                            text={sale.status}
                          />
                        </td>
                        <td>PKR {sale.grand_total}</td>
                        <td>PKR {sale.paid}</td>
                        <td>PKR {sale.due}</td>
                        <td style={{textAlign: 'center'}}>
                          <span
                            className={`badge badge-soft-${
                              sale.payment_status === "Paid"
                                ? "success"
                                : sale.payment_status === "Unpaid"
                                ? "warning"
                                : "danger"
                            } shadow-none badge-xs`}
                          >
                            <i className="ti ti-point-filled me-1"></i>
                            {sale.payment_status}
                          </span>
                        </td>
                        <td className="text-center">
                          <Dropdown
                            menu={getSaleActionsMenu(sale)}
                            trigger={["click"]}
                          >
                            <Button icon={<MoreOutlined />} />
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {total > 0 && (
                <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4 p-3">
                  <div className="pagination-left">
                    Showing {startItem} - {endItem} of {total}
                  </div>
                  <div className="pagination-right d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      disabled={current_page === 1}
                      onClick={() => changePage(current_page - 1)}
                    >
                      <LeftOutlined size={12} />
                    </button>
                    {pagesToShow.map((page, index) => (
                      <span key={index} className="me-2">
                        {page === "..." ? (
                          <span className="pagination-ellipsis">...</span>
                        ) : (
                          <button
                            className={`btn btn-sm ${
                              page === current_page
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => changePage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </span>
                    ))}
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      disabled={current_page === last_page}
                      onClick={() => changePage(current_page + 1)}
                    >
                      <RightOutlined size={12} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <SalesModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={handleAddSale}
          />
          <CustomSaleDetailModal
            open={detailModalOpen}
            onClose={() => setDetailModalOpen(false)}
            sale={selectedSale}
          />
        </div>
      </div>
    </>
  );
};

export default SalesList;

